// Shared, pure label logic for the incident action button used by both BMS Faults
// and Smart Alerts (Platform Alerts), across the accordion list item and the
// DigitalTwin tables. Kept pure and exported so it can be unit-tested without
// rendering. The label is cosmetic — every state opens the same action dialog.

// Status strings (lower-cased) that count as resolved for labelling purposes.
export const RESOLVED_LABEL_STATUSES = ['resolved', 'force resolved', 'auto resolved'];

/**
 * Decide the action button label from the incident's current status and whether the
 * user may update it.
 *   - no update permission            -> "View Details"
 *   - status "open"                   -> "Act Now"
 *   - a resolved status               -> "View Details"
 *   - anything else (in progress, ...)-> "Update"
 * @param {string} status   incident status (bmsAlertStatus / finalStatus)
 * @param {boolean} canUpdate
 * @returns {'Act Now'|'Update'|'View Details'}
 */
export const computeActionLabel = (status, canUpdate) => {
    if (!canUpdate) return 'View Details';
    const key = status?.toLowerCase();
    if (key === 'open') return 'Act Now';
    if (!RESOLVED_LABEL_STATUSES.includes(key)) return 'Update';
    return 'View Details';
};
